import { Button } from "react-bootstrap";

const CursoSelector = ({ cursos, handleCursoClick }) => (
  <div>
    <h6>Selecciona Curso</h6>
    {cursos.map((curso) => (
      <Button
        key={curso.id}
        onClick={() => handleCursoClick(curso)}
        className="asistencia-curso-item"
      >
        {curso.comuna} - {curso.nombre}
      </Button>
    ))}
  </div>
);
export default CursoSelector;
